<!-- 风柜列表 -->
<template>
    <div>
        <el-table
            ref="multipleTable"
            :data="tableData_FG"
            tooltip-effect="dark">
            <!-- <el-table-column
                prop="householdname"
                label="业主名称">
            </el-table-column>
            <el-table-column
                prop="housename"
                label="房间号">
            </el-table-column> -->
            <el-table-column
                prop="deviceType"
                label="表计类型">
            </el-table-column>
            <el-table-column
                prop="deviceModel"
                label="表计型号">
            </el-table-column>
            <el-table-column
                prop="deviceSerial"
                label="序列号"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                label="在线状态"
                show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status === 1 ? 'success': 'danger'">{{fmtOnlineStatus(scope.row)}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                prop="isRunning"
                label="运行状态"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                prop="sysStatus"
                label="故障状态">
                <template slot-scope="scope">
                    <span v-if="scope.row.sysStatus === '正常'">{{scope.row.sysStatus}}</span>
                    <el-tag v-else type="danger">{{scope.row.sysStatus}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                label="累计读数">
                <template slot-scope="scope">
                    <span>{{scope.row.counterTotal + 'KWh'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="settingPowerOn"
                label="开关机">
            </el-table-column>
            <el-table-column
                prop="linkStatus"
                label="通讯状态">
            </el-table-column>
            <el-table-column
                prop="inCounting"
                label="计量状态">
            </el-table-column>
            <el-table-column
                prop="modeStatus"
                label="供冷/供热">
            </el-table-column>
            <el-table-column
                prop="disabled"
                label="使用状态">
            </el-table-column>
            <el-table-column
                prop="balanceAlarm"
                label="余额状态">
            </el-table-column>
            <el-table-column
                prop="allowCharging"
                label="计费状态">
            </el-table-column>
            <el-table-column
                prop="tsensorValue"
                label="传感器温度">
            </el-table-column>
            
            <el-table-column
                fixed="right"
                label="操作"
                width="140">
                <template slot-scope="scope">
                    <el-button @click="handleControlClick(scope.row)" type="text" size="small">控制表计</el-button>
                    <el-button @click="handleDetailClick(scope.row)" type="text" size="small">查看详细</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 详情弹框 -->
        <div>
            <cmp-fg-detail :show.sync="show" :modelData="modelData"></cmp-fg-detail>
        </div>
    </div>
</template>

<script>
import CmpFgDetail from '../CmpEquipmentDetail/CmpFgDetail'
import { funFmtOnlineStatus } from '@/utils/utils'
import checkPermission from '@/utils/permission'

export default {
    name:  'CmpFgTable',
    props: ['tableData_FG'],
    data() {
        return {
            show: false,
            modelData: {},
        };
    },
    components: {
        CmpFgDetail
    },
    methods: {
        // 格式化在线状态
        fmtOnlineStatus(row) {
            return funFmtOnlineStatus(row.status);
        },

        // 查看明细
        handleDetailClick(row) {
            this.show = true;
            this.modelData = row;
        },
        // 控制表计
        handleControlClick(row) {
            if(!checkPermission('device_control')) {
                this.$notify({
                    title: '警告',
                    message: '暂无操作权限',
                    type: 'warning'
                });
                return
            }
            this.$router.push('/equipmentControl/fgInfo/'+ row.terminalid)
        }
    },
}

</script>